// test418
(418 && 0);
